
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 18C3 9.716 9.716 3 18 3a15 15 0 0115 15c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15zm22.612-3.972v-.646a4.248 4.248 0 01-4.23-3.856v-.39h-3.054v12.12A2.566 2.566 0 1116.54 18.8V15.7a5.61 5.61 0 00-3.894 10.216c.894.6 1.968.949 3.125.949a5.61 5.61 0 005.61-5.609v-6.191a7.254 7.254 0 004.231 1.352v-2.388z","fill":"currentColor"}})])
          )
        }
      }
    